import React from "react";
import "../Policy_global.css";
function Privacy() {
  return (
    <div className="window">
      <h1>개인정보 취급방침</h1>

      <div className="content-text">
        ’본디(BONDI)‘(이하 '회사'라 함)는 이용자의 개인정보를 중요시하며,
        "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다.
      </div>
      <div className="content-text">
        회사는 개인정보취급방침을 통하여 이용자가 제공하는 개인정보가 어떠한
        용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가
        취해지고 있는지 알려드립니다.
      </div>
      <div className="title-text">[개인정보 수집 항목] </div>
      <div className="content-text">
        회사는 서비스 제공을 위한 필요 최소한의 개인정보를 수집하고 있습니다.
      </div>
      <div className="content-text">
        회원 가입 시 또는 서비스 이용 과정에서 홈페이지 또는 개별
        어플리케이션이나 프로그램 등을 통해 아래와 같은 서비스 제공을 위해
        필요한 최소한의 개인정보를 수집하고 있습니다.
      </div>

      <div className="content-text">1. 댕친소 계정</div>
      <div className="content-text">필수 </div>
      <div className="content-text">
        이메일, 비밀번호, 이름(닉네임), 프로필사진, 친구목록, 서비스 이용내역,
        서비스 내 구매 및 결제 내역
      </div>
      <div className="content-text">선택</div>
      <div className="content-text">연락처,생년월일, 성별</div>

      <div className="content-text">2. 본인인증 시</div>
      <div className="content-text">
        이름, 성별, 생년월일, 휴대폰번호, 통신사업자, 내/외국인 여부, 암호화된
        이용자 확인 값 (CI), 중복가입확인정보(DI)
      </div>
      <div className="content-text">3. 법정대리인 동의 시</div>
      <div className="content-text">
        법정대리인 정보(이름, 성별, 생년월일, 휴대폰번호, 통신사업자, 내/외국인
        여부, 암호 화된 이용자 확인값(CI), 중복가입확인정보(DI))
      </div>

      <div className="content-text">4. 유료서비스 이용 시</div>
      <div className="content-text">
        신용카드 결제 시: 카드번호(일부), 카드사명 등
      </div>
      <div className="content-text">
        휴대전화번호 결제 시: 휴대전화번호, 결제승인번호 등
      </div>
      <div className="content-text">
        계좌이체 시: 예금주명, 계좌번호, 계좌은행 등
      </div>
      <div className="content-text">
        상품권 이용 시: 상품권 번호, 해당 사이트 아이디
      </div>

      <div className="content-text">5. 환불처리 시</div>
      <div className="content-text">계좌은행, 계좌번호, 예금주명, 이메일</div>

      <div className="title-text">[개인정보의 수집 목적 및 이용]</div>
      <div className="content-text">
        본디는 개인정보를 회원관리, 서비스 제공·개선, 신규 서비스 개발 등을 위해
        이용합니다.
      </div>

      <div className="content-text">
        1. 회원 식별/가입의사 확인,부정이용 방지
      </div>
      <div className="content-text">
        2. 이용자간 메시지 전송, 친구 목록 기능의 제공
      </div>
      <div className="content-text">
        3. 신규 서비스 개발, 다양한 서비스 제공, 문의사항 또는 불만처리,
        공지사항 전달
      </div>
      <div className="content-text">
        4. 유료서비스 이용 시 컨텐츠 등의 전송이나 요금 정산
      </div>
      <div className="content-text">
        5. 서비스의 원활한 운영에 지장을 주는 행위(계정 도용 및 부정 이용 행위
        등 포함)에 대한 방지 및 제재
      </div>
      <div className="content-text">
        6. 인구통계학적 특성과 이용자의 관심, 기호, 성향의 추정을 통한 맞춤형
        컨텐츠 추천 및 마케팅에 활용
      </div>
      <div className="content-text">
        7. 서비스 이용 기록, 접속 빈도 및 서비스 이용에 대한 통계, 프라이버시
        보호 측면의 서비스 환경 구축, 서비스 개선에 활용
      </div>

      <div className="title-text">[개인정보의 보유 및 이용기간] </div>
      <div className="content-text">
        이용자가 회사에서 제공하는 서비스를 이용하는 동안 회사는 이용자의
        개인정보를 계속적으로 보유하며 서비스 제공 등을 위해 이용합니다.
        이용자가 직접 회원탈퇴를 신청하시거나 개인정보 삭제를 요청한 경우 추후
        열람이나 이용이 불가능한 상태로 처리됩니다. 다만, 본디(BONDI)는 불량
        회원의 부정한 이용의 재발을 방지하기 위해 해지 요청일로부터 1년간 해당
        회원의 아이디, 이메일을 보유할 수 있습니다.
      </div>

      <div className="content-text">1. 서비스 특성에 따른 정보 공유</div>
      <div className="content-text">
        이용자가 작성한 공개 의견은 회사에서 제공하는 서비스 특성상 작성자의
        프로필 사진, 이름과 함께 원활한 서비스 제공을 위하여 회사가 서비스를
        제공하는 동안 별도로 보유합니다.
      </div>
      <div className="content-text">a. 본인인증 시</div>

      <div className="content-text">
        이름, 성별, 생년월일, 휴대폰번호, 통신사업자, 내/외국인 여부, 암호화된
        이용 자 확인값(CI), 중복가입확인정보(DI)
      </div>

      <div className="content-text">b. 법정대리인 동의 시</div>

      <div className="content-text">
        법정대리인 정보(이름, 성별, 생년월일, 휴대폰번호, 통신사업자, 내/외국인
        여 부, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI))
      </div>

      <div className="content-text">c. 유료서비스 이용 시 </div>

      <div className="content-text">
        신용카드 결제 시: 카드번호(일부), 카드사명 등
      </div>
      <div className="content-text">
        휴대전화번호 결제 시: 휴대전화번호, 결제승인번호 등
      </div>
      <div className="content-text">
        계좌이체 시: 예금주명, 계좌번호, 계좌은행 등
      </div>
      <div className="content-text">
        상품권 이용 시: 상품권 번호, 해당 사이트 아이디
      </div>

      <div className="content-text">2. 관련 법령에 의한 정보 공유</div>
      <div className="content-text">
        상업, 전자상거래 등에서의 소비자 보호에 관한 법률 등 관련 법령의 규정에
        의하여 일정 기간 정보를 보유하여야 할 필요가 있을 경우 회사는 일정
        기간동안 보유합니다.
      </div>
      <div className="content-text">
        - 계약 또는 청약 철회 등에 관한 기록 보유: 5년 (전자상거래 등에서의
        소비자보호에 관한 법률)
      </div>
      <div className="content-text">
        - 대금 결제 및 재화 등의 공급에 관한 기록 보유: 5년 (전자상거래 등에서의
        소비자보호에 관한 법률)
      </div>
      <div className="content-text">
        - 소비자 불만 또는 분쟁 처리에 관한 기록 보유: 3년 (전자상거래 등에서의
        소비자보호에 관한 법률)
      </div>
      <div className="content-text">
        - 본인 확인에 관한 기록 보유: 6개월 (정보통신망 이용촉진 및 정보보호
        등에 관한 법률)
      </div>

      <div className="title-text">[개인정보의 파기 절차 및 방법] </div>
      <div className="content-text">
        본디(BONDI)는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당
        정보를 지체 없이 파기합니다.
      </div>
      <div className="content-text">파기절차 및 방법은 다음과 같습니다.</div>
      <div className="content-text">
        - 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적
        방법을 사용하여 삭제합니다.
      </div>
      <div className="content-text">
        - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
      </div>

      <div className="title-text">[개인정보의 제 3자 제공 및 취급위탁] </div>
      <div className="content-text">
        본디(BONDI)는 서비스 제공에 필요한 일부 업무(예: 고객 데이터 관리, 결제
        등)를 제 3자에게 위탁하는 경우가 있습니다. 이에 있어서 개인정보의 전부
        또는 일부를 해당 업무 위탁처에 예탁하는 경우가 있습니다. 이 업무위탁처는
        본디(BONDI)를 대신하여 업무를 수행하기 위해서 필요 최소한의 개인정보에만
        액세스하고, 위탁업무의 범위를 넘어서 개인정보를 이용하는 경우는
        없습니다. 회사는 적용 법령을 준수하고 위탁처로서의 적격성을 충분히
        심사함과 동시에 계약에 있어서 비밀유지의무나 데이터보호에 관한 사항을
        규정하는 등 개인정보가 적정하게 관리되는 체제 만들기를 합니다. 회사는
        위탁 업체 변경되는 경우 지체없이 고지를 하며, 위탁 계약 만료에 따른 개인
        정보는 즉각 파기합니다.
      </div>
      <div className="content-text">1. 기본 서비스 제공</div>
      <div className="content-text">
        이용자간 관계 연결 과정에서 이용자의 기본 정보가 공개될 수 있으며, 이미
        연결된 이용자 간에도 공개될 수 있습니다. 또한 이용자가 작성한 공개적
        의견은 프로필 사진, 이름과 함께 타 이용자에게 공개될 수 있습니다.
      </div>
      <div className="content-text">2. 제 3자 제공</div>
      <div className="content-text">- 이용자가 정보 제공에 동의한 경우</div>
      <div className="content-text">
        - 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을
        알아 볼 수 없는 형태로 가공하여 제공하는 경우
      </div>
      <div className="content-text">- 법령에 특별한 규정이 있는 경우</div>
      <div className="content-text">
        - 수사 기관이 수사를 목적으로 정해진 절차와 방법에 따라 요구한 경우
      </div>
      <div className="content-text">3. 위탁 정보</div>
      <div className="content-text">- 데이터 서버</div>
      <div className="content-text">Google firebase</div>
      <div className="content-text">- 서비스 이용 분석</div>
      <div className="content-text">Google firebase</div>

      <div className="title-text">
        [개인정보 자동 수집장치의 설치.운영 및 그 거부에 관한 사항]{" "}
      </div>
      <div className="content-text">
        회사는 이용자의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)' 등을
        운용합니다. 쿠키란, 웹사이트를 방문할 때 고객의 컴퓨터에 저장되는 작은
        텍스트 파일입니다. 이 텍스트 파일은 후일 다시 그 웹사이트를 방문했을
        때에 사이트 운영자가 읽을 수 있는 정보를 보존합니다. 회사는 아래와 같은
        목적으로 Cookie나 유사 웹 추적 기술(웹 비콘, 픽셀 등)을 사용하는 경우가
        있습니다.
      </div>

      <div className="content-text">
        1. 로그인 상태를 기억하고, 방문자 인증이나 세션 유지, 보안대책에
        이용하기 위하여
      </div>
      <div className="content-text">
        2. 언어 등의 설정내용이나 최종 방문일시 등을 기억해 두고, 편리성을
        향상하기 위하여
      </div>
      <div className="content-text">
        3. 방문 회수나 이용 형태 등을 파악하는 것으로 더 좋은 서비스를 제공하기
        위하여
      </div>
      <div className="content-text">
        4. 보다 관심이 높은 광고를 전송하기 위하여
      </div>
      <div className="content-text">5. 광고의 효과를 계측하기 위하여</div>

      <div className="content-text">
        브라우저 설정이나 기타 툴을 이용하여 Cookie 수용 여부를 제어할 수
        있습니다.그러나, 고객이 만약 Cookie를 무효화하거나, Cookie를 설정하는
        기능을 제한하는 경우는 웹사이트의 전부 또는 일부 기능에 액세스할 수 없게
        되고, 그 결과로서 고객의 전체적인 편리성을 제한할 가능성이 있습니다.
      </div>

      <div className="content-text">설정 방법의 예 </div>

      <div className="content-text">1. Internet Explorer의 경우</div>
      <div className="content-text">
        웹 브라우저 상단의 도구 메뉴 {">"} 인터넷 옵션 {">"} 개인정보 {">"} 설정
      </div>

      <div className="content-text">2. Chrome의 경우</div>
      <div className="content-text">
        웹 브라우저 우측의 설정 메뉴 {">"} 화면 하단의 고급 설정 표시 {">"}
        개인정보의 콘텐츠 설정 버튼 {">"} 쿠키
      </div>

      <div className="title-text">[개인정보 보호]</div>

      <div className="content-text">
        본디(BONDI)는 이용자의 소중한 개인정보 보호를 위해 다음의 노력을 하고
        있습니다.
      </div>
      <div className="content-text">
        이용자의 개인정보를 가장 소중한 가치로 여기고 개인정보를 처리함에 있어서
        다음과 같은 노력을 다하고 있습니다.
      </div>

      <div className="content-text">
        이용자의 개인정보를 암호화하고 있습니다.
      </div>
      <div className="content-text">
        이용자의 개인정보를 암호화된 통신구간을 이용하여 전송하고, 비밀번호 등
        중요정보는 암호화하여 보관하고 있습니다.
      </div>

      <div className="content-text">
        해킹이나 컴퓨터 바이러스로부터 보호하기 위하여 노력하고 있습니다.
      </div>
      <div className="content-text">
        해킹이나 컴퓨터 바이러스 등에 의해 이용자의 개인정보가 유출되거나
        훼손되는 것을 막기 위해 데이터를 전문적이고 안전하게 처리해줄 수 있는
        ‘구글(google firebase)’에 위탁하여 처리하고 있습니다. 또한, 해커 등의
        침입을 탐지하고 차단할 수 있는 백신 프로그램을 설치하여 시스템이 최신
        악성코드나 바이러스에 감염되지 않도록 노력하고 있습니다.
      </div>

      <div className="content-text">
        소중한 개인정보에 접근할 수 있는 사람을 최소화하고 있습니다.
      </div>
      <div className="content-text">
        개인정보를 처리하는 직원을 최소화 하며, 개인정보를 보관하는 데이터베이스
        시스템과 개인정보를 처리하는 시스템에 대한 비밀번호의 생성과 변경,
        그리고 접근할 수 있는 권한에 대한 체계적인 기준을 마련하고 지속적인
        감사를 실시하고 있습니다.
      </div>

      <div className="content-text">
        임직원에게 이용자의 개인정보 보호에 대해 정기적인 교육을 실시하고
        있습니다.
      </div>
      <div className="content-text">
        개인정보를 처리하는 모든 임직원들을 대상으로 개인정보보호 의무와 보안에
        대한 정기적인 교육을 실시하고 있습니다.
      </div>

      <div className="title-text">[개인정보에 관한 민원서비스] </div>
      <div className="content-text">
        이용자 및 법정 대리인는 본디(BONDI)의 홈페이지를 통해 언제든지 등록되어
        있는 자신의 개인정보를 조회, 수정할 수 있으며 가입탈퇴를 요청할 수
        있습니다.
      </div>
      <div className="content-text">
        이용자의 개인정보 조회, 수정을 위해서는 회원의 ID와 비밀번호를 체크한 후
        계정관리에서 정보를 입력하고 "수정" 버튼을 클릭하거나 e-mail을 통해
        관리자에게 요청할 수 있습니다.
      </div>
      <div className="content-text">
        혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체없이
        조치하겠 습니다.
      </div>

      <div className="content-text">
        회원가입 등을 통해 개인정보 수집, 이용, 제공에 대해 귀하께서 동의하신
        내용을 귀하는 언제든지 철회하실 수 있습니다. 동의 철회는 회사 사이트의
        '회원탈퇴'를 이용하시거나 관리자에게 e-mail 등을 통해 요청하시면
        언제든지 가능합니다.
      </div>
      <div className="content-text">
        회사는 개인정보 수집에 대한 동의 철회(회원탈퇴)를 개인정보 수집 시와
        동등한 방법 및 절차에 따라 행사할 수 있도록 하겠습니다.
      </div>
      <div className="content-text">
        회사는 이용자의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기
        위하여 아래와 같이 개인정보관리책임자를 지정하고 있습니다.
      </div>
      <div className="content-text">개인정보관리책임자 성명 : 박상빈</div>
      <div className="content-text">전화번호 : 010-3013-0317</div>
      <div className="content-text">이메일 : bondiofficial2021@gmail.com</div>
      <div className="content-text">
        본디(BONDI)의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을
        개인정보관리책임자 혹은 담당 부서로 신고하실 수 있습니다. 회사는
        이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
      </div>
      <div className="content-text">
        기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에
        문의하시기 바랍니다.
      </div>

      <div className="content-text">1. 개인정보침해 신고센터</div>
      <div className="content-text">(국번없이)118</div>
      <div className="content-text">http://privacy.kisa.or.kr</div>
      <div className="content-text">2. 대검찰청 사이버 범죄 수사</div>
      <div className="content-text">02–3480–3571</div>
      <div className="content-text">cybercid@spo.go.kr</div>
      <div className="content-text">3. 경찰청 사이버테러대응센터</div>
      <div className="content-text">182</div>
      <div className="content-text">http://www.ctrc.go.kr</div>

      <div className="title-text">[기타]</div>
      <div className="content-text">
        서비스 내에 링크되어 있는 웹사이트들이 개인정보를 수집하는 행위에
        대해서는 본 “개인정보취급방침”이 적용되지 않음을 알려 드립니다.
      </div>
      <div className="title-text">[고지의 의무]</div>
      <div className="content-text">
        현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소
        7일전부터 서비스 내의 “공지사항” 또는 기타 알기쉬운 방법을 통해 고지할
        것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자
        권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.
      </div>
      <div className="content-text">공지일자: 2022년 05월 30일 </div>
      <div className="content-text">시행일자: 2022년 05월 30일</div>
      <div className="content-text">
        본디(BONDI)는 이용자 여러분의 정보를 소중히 생각하며, 이용자가 더욱
        안심하고 서비스를 이용할 수 있도록 최선의 노력을 다 할 것을
        약속드립니다.
      </div>
    </div>
  );
}

export default Privacy;
